import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/auth.guard';
import { RestaurantGuard } from './services/restaurant.guard';
import { LoginComponent } from './layouts/login/login.component';
import { MainComponent } from './layouts/main/main.component';
import { NotFoundComponent } from './layouts/not-found/not-found.component';

const routes: Routes = [
  //{ path: '', redirectTo: 'login' },
  { path: '', component: LoginComponent },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'admin/dashboard',
        loadChildren: 'src/app/pages/adminPanel/admin-dashboard/admin-dashboard.module#AdminDashboardModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/restaurants',
        loadChildren: 'src/app/pages/adminPanel/restaurants/restaurants.module#RestaurantsModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/new-restaurant',
        loadChildren: 'src/app/pages/adminPanel/new-restaurant/new-restaurant.module#NewRestaurantModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/order-monitoring',
        loadChildren: 'src/app/pages/adminPanel/admin-order-monitoring/admin-order-monitoring.module#AdminOrderMonitoringModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/reservation',
        loadChildren: 'src/app/pages/adminPanel/admin-reservation-monitoring/admin-reservation-monitoring.module#AdminReservationMonitoringModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/user-tracking',
        loadChildren: 'src/app/pages/adminPanel/user/admin-user-monitoring/admin-user-monitoring.module#AdminUserMonitoringModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/user-blocklist',
        loadChildren: 'src/app/pages/adminPanel/user/admin-user-blocklist/admin-user-blocklist.module#AdminUserBlocklistModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/system-admin-users',
        loadChildren: 'src/app/pages/adminPanel/user/system-admin-users/system-admin-users.module#SystemAdminUsersModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/system-user-activities',
        loadChildren: 'src/app/pages/adminPanel/user/system-user-activities/system-user-activities.module#SystemUserActivitiesModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/chain-management',
        loadChildren: 'src/app/pages/adminPanel/chain-management/chain-management.module#ChainManagementModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/user/platform-credentials',
        loadChildren: 'src/app/pages/adminPanel/platform-credentials-admin/platform-credentials-admin.module#PlatformCredentialsAdminModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/billing/sales-report',
        loadChildren: 'src/app/pages/adminPanel/billing/salles-report/salles-report.module#SallesReportModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/billing/restaurant-report-details',
        loadChildren: 'src/app/pages/adminPanel/billing/restaurant-report-details/restaurant-report-details.module#RestaurantReportDetailsModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        ///admin/marketing/sms-package
        path: 'admin/billing/transaction',
        loadChildren: 'src/app/pages/adminPanel/billing/transaction/transaction.module#TransactionModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/billing/transaction-summary',
        loadChildren: 'src/app/pages/adminPanel/billing/transaction-summary/transaction-summary.module#TransactionSummaryModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        ///admin/marketing/sms-package
        path: 'admin/marketing/sms-package',
        loadChildren: 'src/app/pages/adminPanel/marketing/marketing.module#MarketingModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/admin-stripe-accounts',
        loadChildren: 'src/app/pages/adminPanel/stripe-key-admin/stripe-key-admin.module#StripeKeyAdminModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/admin-system-logs',
        loadChildren: 'src/app/pages/adminPanel/system-logs/system-logs.module#SystemLogsModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/restaurant-health',
        loadChildren: 'src/app/pages/adminPanel/restaurant-health/restaurant-health.module#RestaurantHealthModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },
      {
        path: 'admin/restaurant-synopsis',
        loadChildren: 'src/app/pages/adminPanel/restaurant-synopsis/restaurant-synopsis.module#RestaurantSynopsisModule',
        canActivate: [AuthGuard],
        data: { roles: [0] }
      },

      //restaurant panel start
      {
        path: 'restaurant/dashboard',
        loadChildren: 'src/app/pages/restaurantPanel/dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/monitoring/order',
        loadChildren: 'src/app/pages/restaurantPanel/order-monitoring/order-monitoring.module#OrderMonitoringModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/monitoring/reservation',
        loadChildren: 'src/app/pages/restaurantPanel/reservation-monitoring/reservation-monitoring.module#ReservationMonitoringModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/monitoring/review',
        loadChildren: 'src/app/pages/restaurantPanel/review-monitoring/review-monitoring.module#ReviewMonitoringModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/crm',
        loadChildren: 'src/app/pages/restaurantPanel/integration/crm-integration/crm-integration.module#CrmIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/payment-integration',
        loadChildren: 'src/app/pages/restaurantPanel/integration/payment-integration/payment-integration.module#PaymentIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/web',
        loadChildren: 'src/app/pages/restaurantPanel/integration/web-integration/web-integration.module#WebIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/social-media',
        loadChildren: 'src/app/pages/restaurantPanel/integration/social-media-integration/social-media-integration.module#SocialMediaIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/delivery-platform-integration',
        loadChildren: 'src/app/pages/restaurantPanel/integration/delivery-platform-integration/delivery-platform-integration.module#DeliveryPlatformIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/booking-platform-integration',
        loadChildren: 'src/app/pages/restaurantPanel/integration/booking-platform-integration/booking-platform-integration.module#BookingPlatformIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/integration/just-eat-daas',
        loadChildren: 'src/app/pages/restaurantPanel/integration/just-eat-daas-integration/just-eat-daas-integration.module#JustEatDaasIntegrationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [0, 1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/cuisine',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/cuisine/cuisine.module#CuisineModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/course',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/course/course.module#CourseModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/category',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/category/category.module#CategoryModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/grp-dish',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/grp-dish/grp-dish.module#GrpDishModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/dish',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/dish/dish.module#DishModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/pizza-dish/list',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/pizza-dish/menu-list/menu-list.module#MenuListModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/pizza-dish/entry',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/pizza-dish/menu-entry/menu-entry.module#MenuEntryModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/ala-carta',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/ala-carta/ala-carta.module#AlaCartaModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/menu-setup/duplicate-menu',
        loadChildren: 'src/app/pages/restaurantPanel/menu-setup/duplicate-menu/duplicate-menu.module#DuplicateMenuModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/cms',
        loadChildren: 'src/app/pages/restaurantPanel/cms/all-pages/all-pages.module#AllPagesModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/custom-pages',
        loadChildren: 'src/app/pages/restaurantPanel/cms/custom-pages/custom-pages.module#CustomPagesModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/seo',
        loadChildren: 'src/app/pages/restaurantPanel/cms/seo/seo.module#SeoModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/custom-css',
        loadChildren: 'src/app/pages/restaurantPanel/cms/custom-css/custom-css.module#CustomCssModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/schedule',
        loadChildren: 'src/app/pages/restaurantPanel/schedule-management/schedule-management.module#ScheduleManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/new-schedule',
        loadChildren: 'src/app/pages/restaurantPanel/new-schedule-management/new-schedule-management.module#NewScheduleManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/delivery-zone',
        loadChildren: 'src/app/pages/restaurantPanel/delivery-area-management/delivery-area-management.module#DeliveryAreaManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/booking-setting',
        loadChildren: 'src/app/pages/restaurantPanel/restaurant-booking-setting/restaurant-booking-setting.module#RestaurantBookingSettingModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/configurations',
        loadChildren: 'src/app/pages/restaurantPanel/restaurant-basic-information/restaurant-basic-information.module#RestaurantBasicInformationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/primary-configurations',
        loadChildren: 'src/app/pages/restaurantPanel/restaurant-basic-information/restaurant-basic-information.module#RestaurantBasicInformationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/setting/printer-setting',
        loadChildren: 'src/app/pages/restaurantPanel/printer-setting/printer-setting.module#PrinterSettingModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/promotions-and-deals',
        loadChildren: 'src/app/pages/restaurantPanel/promotion-management/promotion-management.module#PromotionManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/booking-deals',
        loadChildren: 'src/app/pages/restaurantPanel/booking-deals/booking-deals.module#BookingDealsModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/vouchers',
        loadChildren: 'src/app/pages/restaurantPanel/voucher/voucher.module#VoucherModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/coupon',
        loadChildren: 'src/app/pages/restaurantPanel/coupon-management/coupon-management.module#CouponManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/service-config',
        loadChildren: 'src/app/pages/restaurantPanel/restaurant-service-configuration/restaurant-service-configuration.module#RestaurantServiceConfigurationModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/event-management',
        loadChildren: 'src/app/pages/restaurantPanel/event-management/event-management.module#EventManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/blog-management',
        loadChildren: 'src/app/pages/restaurantPanel/blog-management/blog-management.module#BlogManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/management/loyalty-points',
        loadChildren: 'src/app/pages/restaurantPanel/loyalty-points/loyalty-points.module#LoyaltyPointsModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },

      {
        path: 'restaurant/customers',
        loadChildren: 'src/app/pages/restaurantPanel/customers/customers.module#CustomersModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/driver-management',
        loadChildren: 'src/app/pages/restaurantPanel/driver-management/driver-management.module#DriverManagementModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/system-user',
        loadChildren: 'src/app/pages/restaurantPanel/system-users/system-users.module#SystemUsersModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },
      {
        path: 'restaurant/app-version-control',
        loadChildren: 'src/app/pages/restaurantPanel/app-version-control/app-version-control.module#AppVersionControlModule',
        canActivate: [AuthGuard, RestaurantGuard],
        data: { roles: [1, 2, 3, 4] }
      },

    ]
  },
  {
    path: 'client-details/:restaurantId',
    loadChildren: 'src/app/layouts/client-details/client-details.module#ClientDetailsModule'
  },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: '/not-found' }
]


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
